import { Component, OnInit, HostListener } from '@angular/core';
import { CommentModalService } from '@app/shared/services/comment-modal.service';

@Component({
  selector: 'app-comment-modal',
  templateUrl: './comment-modal.component.html',
  styleUrls: ['./comment-modal.component.css']
})
export class CommentModalComponent implements OnInit {
  commentsModalData: any;

  @HostListener('document:keyup', ['$event']) keyups(event: KeyboardEvent): void {
    if (event.keyCode === 27) {
      this.cancel();
    }
  }
  constructor(
    private commentModalService: CommentModalService
  ) { }

  ngOnInit() {
    this.getModalData();
  }

  getModalData() {
    this.commentModalService.modalEventObserable.subscribe((data: any) => {
      this.commentsModalData = data;

    })
  }

  cancel() {
    this.commentModalService.modalStatus(false, null);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/comment-modal/comment-modal.component.ts